import React from 'react';
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Image from '../../image'
import Button from '../../ui/button'
import {
    BoxLargeImgWrap,
    BoxLargeImgInner,
    BoxLargeImgMedia,
    BoxLargeImgLink,
    BoxLargeImgContent,
    HeadingWrap,
    CategoryWrap,
    TextWrap,
    BoxLargeImgBtnWrap
} from './box-large-image.style'

const BoxLargeImage = ({ imageSrc, title, category, desc, path, btnText, ...boxStyles }) => {
    const { boxStyle, contentBoxStyle, headingStyle, descStyle, btnStyle } = boxStyles;
    const boxImage = getImage(imageSrc);
    /* if(imageSrc.fixed && typeof imageSrc.fixed !== 'function'){
        boxImage = <GatsbyImage image={imageSrc.gatsbyImageData} alt={title} />;
    }else if(imageSrc.fluid){
        boxImage = <Image fluid image={imageSrc.fluid} alt={title}/>;
    }else{
        boxImage = <img src={imageSrc} alt={title}/>;
    } */

    return (
        <BoxLargeImgWrap {...boxStyle}>
            <BoxLargeImgInner>
                {imageSrc && (
                    <BoxLargeImgMedia>
                        {boxImage ? <GatsbyImage image={boxImage} alt={title} /> : <img src={imageSrc} alt={title} />}
                        <BoxLargeImgLink path={path}>{title}</BoxLargeImgLink>
                    </BoxLargeImgMedia>
                )}
                <BoxLargeImgContent {...contentBoxStyle}>
                    {title && <HeadingWrap as="h5" {...headingStyle}>{title}</HeadingWrap>}
                    {category && <CategoryWrap>{category}</CategoryWrap>}
                    {desc && <TextWrap {...descStyle}>{desc}</TextWrap>}
                    <BoxLargeImgBtnWrap>
                        <Button
                            {...btnStyle}
                            className="button"
                            to={path}
                            iconname="far fa-long-arrow-right">{btnText}</Button>
                    </BoxLargeImgBtnWrap>
                </BoxLargeImgContent>
            </BoxLargeImgInner>
        </BoxLargeImgWrap>
    )
}

BoxLargeImage.propTypes = {
    title: PropTypes.string,
    imageSrc: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    desc: PropTypes.string,
    path: PropTypes.string,
    btnText: PropTypes.string,
    headingStyle: PropTypes.object,
    descStyle: PropTypes.object,
    btnStyle: PropTypes.object
}

BoxLargeImage.defaultProps = {
    path: '/',
    btnText: 'Discover Now',
    btnStyle: {
        iconposition: "right",
        icondistance: "8px",
        varient: "texted",
        hover: "false",
        display: 'flex',
        justify: 'center',
        alignitems: 'center',
        height: '100%'
    }
}


export default BoxLargeImage;
